/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Registration_Page_SubtitleInputs */

const en_company_registration_page_subtitle = /** @type {(inputs: Company_Registration_Page_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Register your company for the Matching Week platform.`)
};

const de_company_registration_page_subtitle = /** @type {(inputs: Company_Registration_Page_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrieren Sie Ihr Unternehmen für die Matching Week Plattform.`)
};

/**
* | output |
* | --- |
* | "Register your company for the Matching Week platform." |
*
* @param {Company_Registration_Page_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_registration_page_subtitle = /** @type {((inputs?: Company_Registration_Page_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Registration_Page_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_registration_page_subtitle(inputs)
	return en_company_registration_page_subtitle(inputs)
});